import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKeys from "../constants/queryKeys";
import documentService from "../services/documentService";

interface AddAccountFileVariables {
    formData: FormData;
    accountId: number | string;
    fileTypeHS: number;
    documentType: number;
}

const useAddAccountFile = () => {
    const queryClient = useQueryClient();
    return useMutation<unknown, Error, AddAccountFileVariables>({
        mutationFn: ({ formData, accountId, fileTypeHS, documentType }) =>
            documentService.uploadAccountFile(formData, accountId, fileTypeHS, documentType),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: [queryKeys.accountFiles] }),
    });
};

export default useAddAccountFile;
